export default __webpack_public_path__ + "static/media/egle.9810f8c3.jpeg";